import { RentalsActionTypes } from "./constants";

export interface RentalActionType {
  type: RentalsActionTypes.API_RESPONSE_SUCCESS | RentalsActionTypes.API_RESPONSE_ERROR | RentalsActionTypes.GET_RENTALS;

  payload: {} | string;
}

// Common success
export const RentalsApiResponseSuccess = (actionType: string, data: any | {}): RentalActionType => ({
  type: RentalsActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});

// Common error
export const RentalsApiResponseError = (actionType: string, error: string): RentalActionType => ({
  type: RentalsActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

// Get rentals
export const getRentals = (start_date?: string, user?: string, status?: string): RentalActionType => ({
  type: RentalsActionTypes.GET_RENTALS,
  payload: {
    start_date,
    user,
    status,
  },
});
